import React, {Component} from 'react'

import {Typography} from '@material-ui/core'

import PaperBlock from "../../../ui/PaperBlock"

/**
 * title
 */

class TitlePanel extends Component {

    render() {
        return <PaperBlock style = {{display: "flex"}}>
            <Typography variant='h5'>{this.props.title}</Typography>
        </PaperBlock>
    }

}

export default TitlePanel